import React, { useEffect, useState } from 'react'
import { useTheme } from '../../context/ThemeContext';
import loadLightIcon from '../../images/icons/load-light.gif'
import loadDarkIcon from '../../images/icons/load-dark.gif'
import { useNavigate } from 'react-router-dom';
import { APIGetActiveEarlyWarningCount } from '../../services/DashboardService';
import { useNotification } from '../../context/NotificationContext';

type DashboardActiveWarningCardPropsType = {
    width?: string;
    height?: string;
    backgroundColor?: string;
    gridArea: string;
}

const DashboardActiveWarningCard = (props: DashboardActiveWarningCardPropsType) => {

    const { theme } = useTheme()
    const navigate = useNavigate()

    const [activeWarningCount, setActiveWarningCount] = useState<number>(0)
    const [isLoading, setIsLoading] = useState<boolean>(false)

    const [isNeedReloading, setIsNeedReloading] = useState<boolean>(false)

    const { notifications, unreadCount, removeNotification } = useNotification()

    useEffect(() => {
        if (notifications.length > 0) 
        {
            const latest = notifications[0]
            //console.log(`🔔 New: ${latest.title} - ${latest.message}`)
            switch (latest.title)
            {
                case 'NEW_ACTIVE_WARNING':
                    setIsNeedReloading(prevState => !prevState)
                    break

            }
        }
    }, [notifications])

    const getActiveEarlyWarningCount = async () => {
        setIsLoading(true)
        const response = await APIGetActiveEarlyWarningCount()

        if (response.status)
        {
            //console.log("COUNT -> " , response.count)
            setActiveWarningCount(response.count)
        }
        setIsLoading(false)
    }

    useEffect(() => {
       getActiveEarlyWarningCount()
    }, [isNeedReloading])

    return (
        <div className='dashboard-pending-count-card' style={{width: props.width ? props.width : '100%', height: props.height ? props.height : '5rem', backgroundColor: props.backgroundColor ? props.backgroundColor : 'var(--color-side-menu-bg)', gridArea: props.gridArea, border: theme === 'light' ? 'solid 1px gray' : ''}} onClick={(e) => navigate('/early_warning/early_warning_messages')}>
            {isLoading ? (
                <img src={theme === 'dark' ? loadDarkIcon : theme === 'light' ? loadLightIcon : theme === 'colorful' ? loadLightIcon : ''} />
                ) : (
                    <span className="count">{activeWarningCount}</span>
                )
            }
            <span className="name">Active early warning count</span>
        </div>
    )
}

export default DashboardActiveWarningCard